import { IconInfoCircle } from "@tabler/icons-react";
import { Tooltip, Typography } from "@altimateai/lego";
import { ReactNode } from "react";

interface Props {
  title: string;
  content: ReactNode;
}

const ChartInfoIcon = ({ title, content }: Props) => {
  return (
    <Tooltip
      title={
        <div className="al-max-w-xs">
          <Typography weight="medium" size="sm">
            {title}
          </Typography>
          <Typography size="sm" className="al-text-gray-900">
            {content}
          </Typography>
        </div>
      }
    >
      <span className="al-cursor-help al-text-gray-400 hover:al-text-gray-600">
        <IconInfoCircle size={16} />
      </span>
    </Tooltip>
  );
};

export default ChartInfoIcon;
